import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, AlertTriangle } from "lucide-react";
import { FadeIn, Eyebrow } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { RESOURCES, RURAL_REVIEW_DATE } from "@/data/rural";

const RuralResources = () => (
  <div data-testid="rural-resources-page">
    <Seo title="Rural Safety & Environmental Resource Hub" description="Official NSW links for rural landowners: RFS fire ratings, SES flood warnings, Planning Portal, agritourism guidance, biosecurity, biodiversity and land tax." />
    <section className="bg-sand-light/40">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Link to="/rural" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.16em] text-charcoal/60 hover:text-teal transition-colors">
          <ArrowLeft className="w-4 h-4" /> Rural Land
        </Link>
        <h1 className="mt-5 font-serif text-3xl sm:text-4xl text-teal tracking-tight">Rural Safety &amp; Environmental Resource Hub</h1>
        <p className="mt-3 text-charcoal/70 leading-relaxed max-w-2xl">
          The official sources, in one place. We link directly to authorities rather than
          reproducing live warnings — always check current conditions yourself before guests arrive.
        </p>
      </div>
    </section>

    <section className="py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        {RESOURCES.map((g, gi) => (
          <FadeIn key={g.group} delay={gi * 0.04}>
            <div className="bg-white border border-cloud" data-testid={`resource-group-${gi}`}>
              <div className="px-6 py-4 border-b border-cloud">
                <Eyebrow>{g.group}</Eyebrow>
                {g.note && (
                  <p className="mt-2 flex gap-2 text-xs text-charcoal/60 leading-relaxed">
                    <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" /> {g.note}
                  </p>
                )}
              </div>
              <ul className="divide-y divide-cloud">
                {g.links.map((l) => (
                  <li key={l.url}>
                    <a
                      href={l.url}
                      target="_blank"
                      rel="noreferrer"
                      data-testid={`resource-link-${l.label.slice(0, 24).replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                      className="flex items-center justify-between gap-4 px-6 py-4 text-sm text-charcoal/85 hover:bg-sand-light/40 hover:text-teal transition-colors"
                    >
                      {l.label}
                      <ExternalLink className="w-4 h-4 text-charcoal/40 shrink-0" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>
        ))}
        <p className="text-xs text-charcoal/55">Links verified {RURAL_REVIEW_DATE}.</p>
      </div>
    </section>
  </div>
);

export default RuralResources;
